export default __webpack_public_path__ + "static/casecard4-eaa0daa92bb8394df05dda51af706689.jpg";